<template>
  <section
    class="component-d7bb860f"
    resmed-component-name="info_50/50_icon-line_list_image"
    v-bind:style="{
      'background-color': acf.layout['background-color'],
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-12 col-md-6"
            v-bind:class="{
              'order-md-2': acf.layout['image-placement'] === 'right',
            }"
          >
            <figure
              class="embed-responsive embed-responsive-4by3"
              v-bind:style="{
                'background-image': `url(${acf.image.sizes.large})`,
                'background-position': acf.layout['background-position'],
              }"
            ></figure>
          </div>
          <div
            class="col-12 col-md-6 align-self-center"
            v-bind:class="{
              'justify-content-end': acf.layout['image-placement'] === 'right',
            }"
          >
            <div class="wrapper">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
              ></eyebrow-icon>
              <h2 v-html="acf.headline"></h2>
              <div
                class="introduction"
                v-if="acf.introduction"
                v-html="acf.introduction"
              ></div>

              <ul v-if="acf.content" class="mt-4">
                <li v-for="(content, index) in acf.content">
                  <div class="numbers" v-if="acf.layout['list-style'] === 'ol'">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <div class="bullets" v-if="acf.layout['list-style'] === 'ul'">
                    <span>•</span>
                  </div>
                  <span v-html="content.item"></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-d7bb860f", // info_50/50_icon-line_list_image
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-d7bb860f {
  // -->
}

.component {
  &.text-color-white {
    h2,
    li {
      color: $cc-resmed-white;
    }

    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }

    ul {
      li:not(:last-child) {
        border-bottom: 1px solid rgba($cc-resmed-white, 0.25);
      }

      li {
        > .numbers span {
          border: 1px solid $cc-resmed-white;
        }
      }
    }
  }

  &.text-color-black {
    ul {
      li:not(:last-child) {
        border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.25);
      }

      li {
        > .numbers span {
          border: 1px solid rgba($cc-resmed-dark-grey, 0.325);
        }
      }
    }
  }

  h2 {
    position: relative;
    margin-bottom: 1rem;

    @extend %eyebrow-left;
  }

  .introduction {
    max-width: 490px;
  }

  [class^="col"] {
    padding: 0;

    display: flex;
    align-items: center;
    align-items: stretch;
  }

  figure {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .wrapper {
    padding: 5rem 3rem;
    flex-grow: 1;

    @media (min-width: 768px) {
      max-width: 730px;
    }

    @media (min-width: 992px) {
      padding: 6rem;
    }
  }

  ul {
    list-style: none;

    li:not(:last-child) {
      margin-bottom: 1.25rem;
      padding-bottom: 1.25rem;
    }

    li {
      > span {
        display: block;
        padding-left: 2.5rem;
      }

      .bullets {
        span {
          transform: scale(1.75);
        }
      }

      .numbers {
        span {
          //
        }
      }

      .bullets,
      .numbers {
        overflow: hidden;
        float: left;
        transform: translate3d(0, 0, 0);

        span {
          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 50%;
          width: 1.75rem;
          height: 1.75rem;

          text-align: center;

          @extend %body-small;
        }
      }
    }
  }
}
</style>